import { createRequestFilters, ListProviderCollectionPaymentsRequest, ProviderCollectionPayment } from '@enter/core';
import _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import type { PaymentGenerator } from './payment.generator';
import { PaymentService } from './payment.service';
import { IFeatures, IItemDetail, IItemListing, IItemListingRequest } from './root.store';
import { appendTo, parseItemListingRequest } from './util';

export class PaymentStore {
    @observable public payments: ProviderCollectionPayment[] = [];

    private features: IFeatures;
    private paymentGenerator: PaymentGenerator;
    private paymentService: PaymentService = new PaymentService();

    constructor(features: IFeatures, paymentGenerator: PaymentGenerator) {
        this.features = features;
        this.paymentGenerator = paymentGenerator;
    }

    @action
    public async loadPaymentListing(ilr: IItemListingRequest): Promise<IItemListing<ProviderCollectionPayment>> {
        const lpgr = ilr2lpgr(ilr);
        const listing = await (this.features.isDemo
            ? this.paymentGenerator.loadPaymentListing(lpgr)
            : this.paymentService.fetchPaymentListing(lpgr));
        if (!listing) {
            throw new Error(`No payments available`);
        }
        const { items } = listing;
        runInAction(() => {
            this.payments = appendTo<ProviderCollectionPayment>(this.payments, items);
        });
        return listing;
    }
}

// Convert from IItemListingRequest to ListProviderCollectionPaymentsRequest
export const ilr2lpgr = (ilr: IItemListingRequest): ListProviderCollectionPaymentsRequest => {
    const base = parseItemListingRequest(ilr) as ListProviderCollectionPaymentsRequest;
    const filters = createRequestFilters(_.get(ilr, 'filters'), true);
    return {
        ...base,
        ...filters,
    };
};
